import React, { ElementRef, useRef } from 'react';
import { SectionTitle } from '../../../components/SectionTitle';
import { Button } from '../../../components/Button';
import { Container } from '../../../components/Container';
import {S} from './Contacts_Styles';
import emailjs from '@emailjs/browser';

export const Contact: React.FC = () => {
    const form = useRef<ElementRef<'form'>>(null);

    const sendEmail = (e: any) => {
      e.preventDefault();
      if(!form.current) return
  
      emailjs
        .sendForm('service_kgodacm', 'template_dv2rxbb', form.current, {
          publicKey: 'dyxtUUlS8SWvBmbv2',
        })
        .then(
          () => {
            console.log('SUCCESS!');
          },
          (error) => {
            console.log('FAILED...', error.text);
          },);
          e.target.reset()
    };

    return (
        <S.Contacts id={"contacts"}>
            <Container>    
            <SectionTitle>Contacts</SectionTitle>
            <S.Form ref={form} onSubmit={sendEmail}>
                <S.Field required placeholder={"Name"} name={"user_name"} />
                <S.Field required placeholder={"email"} name={"user_email"} />
                <S.Field required placeholder={"subject"} name={"subject"} />
                <S.Field required placeholder={"Your message"} as={"textarea"} name={"message"} />
                <Button type={"submit"}>Send Message</Button>
            </S.Form>
            </Container>
        </S.Contacts>
    );
};


